import axios from 'axios'

// config
import baseUrl from '../config'

export const bulkRegenerateAgreements = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/bulk-regenerate-documents`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const bulkUploadDocuments = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/bulk-upload-documents`,
    data
  })

  return response.data
}

export const fetchBulkDocumentUploadStatus = async ({ uuid }) => {
  const response = await axios.get(`${baseUrl}/sef/bulk-document-upload/${uuid}`, {
    withCredentials: true
  })

  return response.data
}

export const bulkRegenerateArchives = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/bulk-regenerate-archives`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const bulkRegeneratePayslips = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/bulk-regenerate-payslips`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const createAgreementTemplate = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/agreement-templates`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const createBudget = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/budgets`,
    data
  })

  return response.data
}

export const createBudgetCategory = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/budget-categories`,
    data
  })

  return response.data
}

export const createForm = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/forms`,
    data
  })

  return response.data
}

export const createOutputArea = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/output-areas`,
    data
  })

  return response.data
}

export const createOutputIndicator = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/output-indicators`,
    data
  })

  return response.data
}

export const createPartner = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/partners`,
    data
  })

  return response.data
}

export const createPartnerDistrict = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/partner-districts`,
    data
  })

  return response.data
}

export const createPayfile = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/payfiles`,
    data
  })

  return response.data
}

export const createSupplier = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/suppliers`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const createWorksite = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/worksites`,
    data
  })

  return response.data
}

export const createWorkspace = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/workspaces`,
    data
  })

  return response.data
}

export const createWorkspaceProject = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/workspace-projects`,
    data
  })

  return response.data
}

export const deleteBudget = async ({ budgetId }) => {
  return await axios.delete(`${baseUrl}/sef/budgets/${budgetId}`, { withCredentials: true })
}

export const deleteBudgetCategory = async ({ budgetCategoryId }) => {
  return await axios.delete(`${baseUrl}/sef/budget-categories/${budgetCategoryId}`, {
    withCredentials: true
  })
}

export const deleteForm = async ({ formId }) => {
  return await axios.delete(`${baseUrl}/sef/forms/${formId}`, { withCredentials: true })
}

export const deleteOutput = async ({ outputId }) => {
  return await axios.delete(`${baseUrl}/sef/indicator-outputs/${outputId}`, {
    withCredentials: true
  })
}

export const deleteOutputArea = async ({ outputAreaId }) => {
  return await axios.delete(`${baseUrl}/sef/output-areas/${outputAreaId}`, {
    withCredentials: true
  })
}

export const deleteOutputIndicator = async ({ indicatorId }) => {
  return await axios.delete(`${baseUrl}/sef/output-indicators/${indicatorId}`, {
    withCredentials: true
  })
}

export const deletePartnerDistrict = async ({ partnerDistrictId }) => {
  return await axios.delete(`${baseUrl}/sef/partner-districts/${partnerDistrictId}`, {
    withCredentials: true
  })
}

export const deleteSupplier = async ({ supplierId }) => {
  return await axios.delete(`${baseUrl}/sef/suppliers/${supplierId}`, { withCredentials: true })
}

export const deleteWorksite = async ({ worksiteId }) => {
  return await axios.delete(`${baseUrl}/sef/worksites/${worksiteId}`, { withCredentials: true })
}

export const deleteWorkspace = async ({ workspaceId }) => {
  return await axios.delete(`${baseUrl}/sef/workspaces/${workspaceId}`, { withCredentials: true })
}

export const deleteWorkspaceProject = async ({ workspaceProjectId }) => {
  return await axios.delete(`${baseUrl}/sef/workspace-projects/${workspaceProjectId}`, {
    withCredentials: true
  })
}

export const downloadBulkAgreements = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/download-bulk-agreements`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const fetchActivityReports = async params => {
  const response = await axios.get(`${baseUrl}/sef/activity-reports`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchAdmins = async params => {
  const response = await axios.get(`${baseUrl}/sef/admin-users`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchAgreementTemplate = async id => {
  const response = await axios.get(`${baseUrl}/sef/agreement-templates/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const fetchAgreementTemplates = async params => {
  const response = await axios.get(`${baseUrl}/sef/agreement-templates`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchBudget = async id => {
  const response = await axios.get(`${baseUrl}/sef/budgets/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const fetchBudgets = async params => {
  const response = await axios.get(`${baseUrl}/sef/budgets`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchBudgetCategories = async params => {
  const response = await axios.get(`${baseUrl}/sef/budget-categories`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchBudgetCategory = async id => {
  const response = await axios.get(`${baseUrl}/sef/budget-categories/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const fetchDistricts = async params => {
  const response = await axios.get(`${baseUrl}/sef/districts`, { withCredentials: true, params })

  return response.data
}

export const fetchDistrictsForOnboarding = async params => {
  const response = await axios.get(`${baseUrl}/sef/districts-for-onboarding`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchEmploymentAgreement = async id => {
  const response = await axios.get(`${baseUrl}/sef/agreements/${id}`, { withCredentials: true })
  return response.data
}

export const fetchEmployeeDetails = async ({ employeeId, worksiteId }) => {
  const response = await axios.get(
    `${baseUrl}/sef/worksites/${worksiteId}/employee/${employeeId}`,
    { withCredentials: true }
  )

  return response.data
}

export const fetchForm = async id => {
  const response = await axios.get(`${baseUrl}/sef/forms/${id}`, { withCredentials: true })

  return response.data
}

export const fetchFormAnswers = async ({ formId, ...params }) => {
  const response = await axios.get(`${baseUrl}/sef/form-answers/${formId}`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchForms = async params => {
  const response = await axios.get(`${baseUrl}/sef/forms`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchMunicipalities = async params => {
  const response = await axios.get(`${baseUrl}/sef/municipalities`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchOnboardingQuestions = async () => {
  const response = await axios.get(`${baseUrl}/sef/onboarding-questions`)

  return response.data
}

export const fetchOutput = async id => {
  const response = await axios.get(`${baseUrl}/sef/indicator-outputs/${id}`, {
    withCredentials: true
  })

  return response.data
}

export const fetchOutputArea = async id => {
  const response = await axios.get(`${baseUrl}/sef/output-areas/${id}`, { withCredentials: true })
  return response.data
}

export const fetchOutputAreas = async params => {
  const response = await axios.get(`${baseUrl}/sef/output-areas`, { withCredentials: true, params })

  return response.data
}

export const fetchOutputIndicator = async id => {
  const response = await axios.get(`${baseUrl}/sef/output-indicators/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const fetchOutputIndicators = async params => {
  const response = await axios.get(`${baseUrl}/sef/output-indicators`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchOutputs = async params => {
  const response = await axios.get(`${baseUrl}/sef/indicator-outputs`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchOwnProfileDetails = async id => {
  const response = await axios.get(`${baseUrl}/sef/profile/${id}`, { withCredentials: true })

  return response.data
}

export const fetchParticipantProfile = async id => {
  const response = await axios.get(`${baseUrl}/sef/participant-profile/${id}`, {
    withCredentials: true
  })
  return response.data
}

export const fetchPartnerDistrict = async ({ id, ...params }) => {
  const response = await axios.get(`${baseUrl}/sef/partner-districts/${id}`, {
    params,
    withCredentials: true
  })
  return response.data
}

export const fetchPartnerDistricts = async params => {
  const response = await axios.get(`${baseUrl}/sef/partner-districts`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchPartners = async params => {
  const response = await axios.get(`${baseUrl}/sef/partners`, { withCredentials: true, params })

  return response.data
}

export const fetchPayrollBalance = async params => {
  const response = await axios.get(`${baseUrl}/sef/payroll-balance`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchPayrollHistory = async params => {
  const response = await axios.get(`${baseUrl}/sef/payroll`, { withCredentials: true, params })

  return response.data
}

export const fetchPayrollPaymentRequest = async id => {
  const response = await axios.get(`${baseUrl}/sef/payroll/${id}`, { withCredentials: true })

  return response.data
}

export const fetchPayrollPaymentRequests = async params => {
  const response = await axios.get(`${baseUrl}/sef/payroll-requests`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const fetchPlace = async id => {
  const response = await axios.get(`${baseUrl}/sef/places/${id}`, { withCredentials: true })
  return response.data
}

export const fetchPlaces = async params => {
  const response = await axios.get(`${baseUrl}/sef/places`, { withCredentials: true, params })

  return response.data
}

export const fetchPrograms = async params => {
  const response = await axios.get(`${baseUrl}/sef/programs`, { withCredentials: true, params })

  return response.data
}

export const fetchScaffoldData = async () => {
  const response = await axios.get(`${baseUrl}/sef/ge-scaffold-data`, { withCredentials: true })

  return response.data
}

export const fetchStats = async params => {
  const response = await axios.get(`${baseUrl}/sef/stats`, { params, withCredentials: true })

  return response.data
}

export const fetchSupplier = async id => {
  const response = await axios.get(`${baseUrl}/sef/suppliers/${id}`, { withCredentials: true })
  return response.data
}

export const fetchSuppliers = async params => {
  const response = await axios.get(`${baseUrl}/sef/suppliers`, { withCredentials: true, params })

  return response.data
}

export const fetchTimekeepers = async params => {
  const response = await axios.get(`${baseUrl}/sef/timekeepers`, { withCredentials: true, params })

  return response.data
}

export const fetchWards = async params => {
  const response = await axios.get(`${baseUrl}/sef/wards`, { withCredentials: true, params })

  return response.data
}

export const fetchWorksite = async ({ id, ...params }) => {
  const response = await axios.get(`${baseUrl}/sef/worksites/${id}`, {
    params,
    withCredentials: true
  })
  return response.data
}

export const fetchWorksites = async params => {
  const response = await axios.get(`${baseUrl}/sef/worksites`, { withCredentials: true, params })

  return response.data
}

export const fetchWorkspace = async id => {
  const response = await axios.get(`${baseUrl}/sef/workspaces/${id}`, { withCredentials: true })
  return response.data
}

export const fetchWorkspaceProject = async id => {
  const response = await axios.get(`${baseUrl}/sef/workspace-projects/${id}`, {
    withCredentials: true
  })

  return response.data
}

export const fetchWorkspaces = async params => {
  const response = await axios.get(`${baseUrl}/sef/workspaces`, { withCredentials: true, params })

  return response.data
}

export const fetchWorkspaceProjects = async params => {
  const response = await axios.get(`${baseUrl}/sef/workspace-projects`, {
    withCredentials: true,
    params
  })

  return response.data
}

export const generatePayfile = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/generate-payfile`,
    data
  })

  return response.data
}

export const importOutputs = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/import-outputs`,
    data
  })
}

export const importKwantuData = async data => {
  if (data.fileType === 'ATT01') {
    return await axios({
      withCredentials: true,
      method: 'post',
      url: `${baseUrl}/sef/import-kwantu-attendance-data`,
      data
    })
  }

  if (data.fileType === 'PAY04F') {
    return await axios({
      withCredentials: true,
      method: 'post',
      url: `${baseUrl}/sef/import-kwantu-payments-data`,
      data
    })
  }
}

export const importParticipants = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/import-participants`,
    data
  })
}

export const initiatePayrollRequest = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/batch-payroll-requests`,
    data
  })

  return response.data
}

export const onboardEmployee = async data => {
  return await axios({
    method: 'put',
    url: `${baseUrl}/sef/partner-districts/onboard-employee`,
    data
  })
}

export const prepareKwantuData = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
    url: `${baseUrl}/sef/prepare-kwantu-data`,
    data
  })
}

export const promoteParticipants = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/promote-participants`,
    data
  })
}

export const provisionIndicatorOutcome = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/indicator-output-provisionings`,
    data
  })

  return response.data
}

export const requestAgreementZip = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/generate-employment-agreement-zip-file`,
    data,
    responseType: 'blob'
  })

  // Create a link element to download the file
  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', 'agreements.zip') // Set the download filename
  document.body.appendChild(link)
  link.click()

  // Cleanup
  link.parentNode.removeChild(link)

  return response.data
}

export const sendOutcomesTrackingReminder = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/indicator-outputs-reminder`,
    data
  })

  return response.data
}

export const submitIndicatorOutcome = async data => {
  return await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/indicator-outputs`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
}

export const toggleSefBioFeature = async id => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/toggle-bio-feature/${id}`
  })

  return response.data
}

export const updateAgreementTemplate = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/agreement-templates/${data.get('id')}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const updateBudget = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/budgets/${data.budgetId || data.id}`,
    data
  })

  return response.data
}

export const updateBudgetCategory = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/budget-categories/${data.budgetCategoryId || data.id}`,
    data
  })

  return response.data
}

export const updateForm = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/forms/${data.formId || data.id}`,
    data
  })

  return response.data
}

export const updateEmploymentAgreement = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'post',
    url: `${baseUrl}/sef/employment-agreement/${data.get('participantId')}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const updateOutput = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/indicator-outputs/${data.get('id')}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const updateOutputArea = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/output-areas/${data.id}`,
    data
  })

  return response.data
}

export const updateOutputIndicator = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/output-indicators/${data.id}`,
    data
  })

  return response.data
}

export const updatePartner = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/partners/${data.partnerId || data.id}`,
    data
  })

  return response.data
}

export const updatePartnerDistrict = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/partner-districts/${data.partnerDistrictId || data.id}`,
    data
  })

  return response.data
}

export const updatePayrollRequest = async data => {
  if (data.status === 'Executed') {
    const response = await axios({
      withCredentials: true,
      method: 'post',
      url: `${baseUrl}/sef/payroll-executions`,
      data
    })

    return response.data
  }

  const response = await axios({
    withCredentials: true,
    method: 'PATCH',
    url: `${baseUrl}/sef/payroll/${data.paymentRequestId}`,
    data
  })

  return response.data
}

export const updatePlace = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/places/${data.placeId || data.id}`,
    data
  })

  return response.data
}

export const updateSupplier = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/suppliers/${data.get('id')}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const updateWorksite = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/worksites/${data.worksiteId || data.id}`,
    data
  })

  return response.data
}

export const updateWorkspace = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/workspaces/${data.workspaceId || data.id}`,
    data
  })

  return response.data
}
export const updateWorkspaceProject = async data => {
  const response = await axios({
    withCredentials: true,
    method: 'put',
    url: `${baseUrl}/sef/workspace-projects/${data.workspaceProjectId || data.id}`,
    data
  })

  return response.data
}
